import React from 'react';

const SubmitMsg = (props) => {
    const msgStyle = {
        position : "absolute",
        top:"10px",
        left:"10px",
        right:"10px",
        backgroundColor : "black",
        color : "white",
        padding : "15px",
        margin : "15px",
        display : props.msg.display
    }
    return(
        <div style={msgStyle}>
            <small>{props.msg.autoClose} </small>
            <h4>{props.msg.heading}</h4>
            <p>{props.msg.text}</p>
        </div>
    );
}

export default SubmitMsg;


// WEBPACK FOOTER //
// ./src/components/SubmitMsg.js